import axios from 'axios';
import { message } from 'antd';
import {
  CUSTOMER_API,
} from '../../../constants/API';
import {
  UPDATE_CUSTOMER_LOADING
} from '../types';


function updateCustomer(data) {
  return async(dispatch, getState) => {
      dispatch({
        type: UPDATE_CUSTOMER_LOADING,
        updatingCustomer: true
      });
      try {
        const accessToken = await localStorage.getItem('accessToken');
        const { userData } = getState().AuthReducer;
        const putData = {
          ...data,
          userId: userData.id
        };
        await axios.put(`${CUSTOMER_API}/${data.id}`, putData, { headers: {"Authorization" : `Bearer ${accessToken}`} })
        
        dispatch({
          type: UPDATE_CUSTOMER_LOADING,
          updatingCustomer: false
        });
      } catch (e) {
        message.error(String(e));
        dispatch({
          type: UPDATE_CUSTOMER_LOADING,
          updatingCustomer: false
        });
        console.log(e);
      }
  }
}
export default updateCustomer;
